import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { StyledWrapper, StyledClickablePill, StyledNotClickablePill } from './UnavailableSeatPill.styles.js';

const UnavailableSeatPill = ({ show, seatStatus }) => {
  const showWithBookings = seatStatus.reference;
  const showWithDifferentInventory = seatStatus.inventoryClass && seatStatus.inventoryClass !== '' && !showWithBookings;
  const showWithBlocked = (seatStatus.blocked || seatStatus.inventoryClass === '') && !(showWithBookings || showWithDifferentInventory);

  if (!show) return null;
  return (
    <StyledWrapper>
      {showWithBookings && (
        <StyledClickablePill data-testid="clickable-pill">
          <Link
            to={{
              pathname: `/manage/bookings/${seatStatus.reference}/journeys`
            }}
            target="_blank"
          >
            <FormattedMessage id="unavailableSeat.pill.withBooking" values={{ seat: seatStatus.seat, reference: seatStatus.reference }} />
          </Link>
        </StyledClickablePill>
      )}
      {showWithDifferentInventory && (
        <StyledNotClickablePill data-testid="not-clickable-pill-different-inventory">
          <FormattedMessage id="unavailableSeat.pill.differentClass" values={{ seat: seatStatus.seat, class: seatStatus.inventoryClass }} />
        </StyledNotClickablePill>
      )}
      {showWithBlocked && (
        <StyledNotClickablePill data-testid="not-clickable-pill-blocked">
          <FormattedMessage id="unavailableSeat.pill.blocked" values={{ seat: seatStatus.seat }} />
        </StyledNotClickablePill>
      )}
    </StyledWrapper>
  );
};

UnavailableSeatPill.propTypes = {
  show: PropTypes.bool,
  seatStatus: PropTypes.shape({
    reference: PropTypes.string,
    seat: PropTypes.string,
    inventoryClass: PropTypes.string,
    blocked: PropTypes.bool
  })
};

export default UnavailableSeatPill;
